import { EditorialModel } from './Editorial.model';
import { MultiLangModel } from './Language.model';

export class CategoryModel {
  constructor(data = {}) {
    Object.assign(this, data);
  }

  editorialId?: string;
  name: MultiLangModel = new MultiLangModel();
  enabled?: boolean;
  id?: string;
  icon?: string;
  editorialName?: MultiLangModel;
}

export class CategoryFilterModel {
  Search?: string;
  PageIndex?: number;
  PageSize?: number;
  Event?: boolean;
  Language?: string;
}
